export { InternalHero } from './InternalHero';
export { default as ValuePoints } from './ValuePoints';
export { default as WhatIsCovered } from './WhatIsCovered';
export { default as TakeBetterCare } from './TakeBetterCare';
export { default as Reviews } from './Reviews/Reviews';
export { default as Pricing } from './Pricing';
export { default as Questions } from './Questions/Questions';
export { default as DoGood } from './DoGood';
export { PetLandingPageType } from './shared';
